import { darken, lighten, makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import { withProps } from "../../../Core/Utils/React/WithProps";

export const HeavyHeader = styled(Typography)`
    font-family: "HelveticaNeue-Heavy";
    letter-spacing: -2.76px;
    line-height: 100%;
`;

const _HeavyParagraph = styled(HeavyHeader)`
    letter-spacing: -0.35px;
    margin-bottom: 6px;
    margin-top: 15px;
`;

export const HeavyParagraph = withProps(_HeavyParagraph)({ component: "p" } as any);

export const PaymentMethods = styled.div``;

/**
 * Contains style information for the property page.
 */
export const PropertyPageStyles = makeStyles((theme: Theme) => ({
    root: {},
    introduction: {
        margin: "18px 18px 12px 18px",
    },
    introductionTitle: {
        fontSize: "12px",
    },
    description: {
        margin: "0px 18px 12px 18px",
        lineClamp: 2,
        "& > div": {
            padding: "0",
            margin: "8px 0",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
        },
        "& > div > a": {
            color: "#556ED1",
            textDecoration: "underline",
            cursor: "pointer",
        },
    },
    reservation: {
        borderTop: "1px solid #7F7F7F",
        margin: "0px 18px 5px 18px",
    },
    reservationTitle: {
        display: "flex",
        fontSize: "12px",
        marginBottom: "11px",
        marginTop: "10px",
        "& > div:first-child": {
            fontWeight: "bold",
            minWidth: "145px",
        },
    },
    status: {
        borderBottom: "1px solid #7F7F7F",
        borderTop: "1px solid #7F7F7F",
        padding: "9px 18px 8px 18px",
        "& > div": {
            margin: "9px 0",
        },
        "& > div > h5": {
            fontSize: "12px",
            fontWeight: "bold",
            marginBottom: "2px",
            textTransform: "uppercase",
        },
        "& > div > div": {
            display: "flex",
        },
    },
    statusTitle: {
        display: "flex",
        flex: "1",
        fontSize: "12px",
        marginBottom: "2px",
        "& > div:first-child": {
            fontWeight: "bold",
            minWidth: "60px",
        },
    },
    titleRow: {
        alignItems: "center",
        backgroundColor: "#F9F9F9",
        display: "flex",
        justifyContent: "space-between",
        minHeight: "72px",
        "& > div": {
            padding: "12px 18px",
            "& > h5": {
                fontSize: "16px",
                fontWeight: "bold",
            },
            "& > p": {
                fontSize: "12px",
            },
        },
    },
    propertyBox: {
        margin: "18px 18px 15px 18px",
    },
    propertyImages: {
        width: "100%",
        maxWidth: "400px",
    },
    topMarginWrapper: {
        paddingTop: "24px",
    },
    accordion: {
        margin: "0 !important",
        "& > div.MuiCollapse-container": {},
    },
    accordionSummary: {},
    propertyTitleRow: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        marginRight: "18px",
    },
    content: {
        background: "#3C3C3B",
        padding: "10px 30px",
    },
    contentTop: {
        display: "flex",
        justifyContent: "space-between",
        gap: "10px",
        alignItems: "center",
    },
    navigateToPropertyItem: {
        minHeight: "52px",
        "& > button": {
            "& > div.MuiCardMedia-root": {
                minHeight: "274px",
                width: "100%",
            },
            "& > div.MuiCardContent-root": {
                padding: "12px 18px",
            },
        },
    },
    imageCard: { width: "599px", height: "440px" },
    titleParent: {
        display: "flex",
        alignItems: "center",
        gap: "4px",
        position: "relative",
    },
    title: {
        display: "flex",
        fontSize: "21px",
        lineHeight: "26px",
        fontWeight: "normal",
        letterSpacing: "-0.53px",
        color: "#FFFFFF",
        fontFamily: '"Inter", sans-serif',
    },
    dropdownArrow: {
        justifySelf: "end",
        alignItems: "center",
        display: "flex",
        transform: "rotate(90deg)",
        marginLeft: "10px",
        "& svg": {
            fill: "#3aaa35",
            marginLeft: "-6px",
            marginRight: "-6px",
            fontSize: "16px",
        },
    },
    [theme.breakpoints.up("md")]: {
        titleRow: {
            alignItems: "flex-start",
            background: "none",
            flexDirection: "column",
            padding: "27px 18px 15px 18px",
            "& > h5": {
                fontSize: "16px",
                fontWeight: "bold",
                marginBottom: "8px",
            },
            "& > p": {
                fontSize: "12px",
                padding: "0px",
            },
        },
        introduction: {
            margin: "27px 18px 15px 18px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flex: "0 0 auto",
            "& > button": {
                padding: "0",
            },
            "& .MuiSvgIcon-root": {
                margin: "-7px",
                fontSize: "35px",
            },
        },
        introductionTitle: {
            fontSize: "22px",
            fontWeight: "bold",
        },
        reservation: {
            display: "flex",
            margin: "6px 18px 15px 18px",
            flex: "0 0 auto",
            "& > div": {
                flex: "1",
            },
            "& > div:last-child > div > div:first-child": {
                // Overrides the reservationTitle first-child width below.
                minWidth: "115px",
            },
        },
        reservationTitle: {
            fontSize: "16px",
            marginBottom: "2px",
            marginRight: "54px",
            "& > div:first-child": {
                minWidth: "200px",
            },
        },
        status: {
            margin: "8px 18px 12px 18px",
            padding: "1px 0",
            flex: "0 0 auto",
            "& > div": {
                margin: "10px 54px 8px 0",
            },
            display: "flex",
            "& > div > h5": {
                fontSize: "14px",
                marginBottom: "3px",
            },
            "& > div > div": {
                flexDirection: "column",
            },
        },
        statusTitle: {
            "& > div:first-child": {
                minWidth: "70px",
            },
        },
        accordion: {
            "& > div.MuiCollapse-container": {
                background: "none",
                borderTop: "1px dashed #ced4da",
                "& div.MuiAccordionDetails-root": {
                    padding: "30px 0px",
                },
            },
        },
        accordionSummary: {
            margin: "0 18px",
            "& > div.MuiAccordionSummary-content": {
                marginLeft: "-18px",
                "& > p": {
                    fontSize: "14px",
                },
            },
            "& > div.MuiAccordionSummary-expandIcon": {
                marginRight: "-18px",
            },
        },
        propertyTitleRow: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginRight: "18px",
        },
        workspace: {
            "& > div": {
                // display: "flex",
                // flexDirection: "row",
                margin: "0",

                "&.cards-container": {
                    height: "100%",
                    minHeight: "400px",
                    maxHeight: "750px",
                },

                "&.company-logo-container": {
                    margin: "60px 0 48px",
                    padding: 0,
                },
            },
        },
    },
    caption: {
        textAlign: "center",
    },
}));

// export const PropertyPageStyles = makeStyles((theme: Theme) => ({}))

/**
 * Contains style information for the payment section.
 */
export const PaymentSectionStyles = makeStyles((theme: Theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
    },
    columnRow: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "60px",
        "& .isMobilePaymentHistory": { display: "none" },
    },
    paymentHistoryCard: {
        border: "1px solid #ECECEC",
        padding: "22px 20px",
        borderRadius: "3px",
        height: "100%",
    },
    paymentRow: {
        display: "flex",
        flexWrap: "wrap",
    },
    paymentRowTitle: {
        fontSize: "18px",
        fontWeight: "bold",
        marginBottom: "22px",
        color: "#191919",
        lineHeight: "22px",
    },
    paymentRowSubTitle: {
        display: "flex",
        fontSize: "14px",
        marginBottom: "5px !important",
        gap: "10px",
        color: "#191919",
        lineHeight: "17px",
        justifyContent: "space-between",
        "& > div:first-child": {
            fontWeight: "bold",
            marginRight: "12px",
        },
        "& > div > div": {
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
        },
    },
    paymentRowTotal: {
        display: "flex",
        fontSize: "18px",
        fontWeight: "bold",
        marginTop: "22px",
        marginBottom: "5px !important",
        gap: "10px",
        color: "#191919",
        lineHeight: "17px",
        justifyContent: "space-between",
        "& > div:first-child": {
            marginRight: "12px",
        },
    },
    paymentSelection: {
        display: "flex",
        flexDirection: "column-reverse",
    },
    paymentMethodRow: {
        display: "flex",
        padding: "20px 0",
        gap: "5px",
    },
    paymentMethod: {
        width: "66px",
        height: "66px",
        background: "#FFFFFF",
        boxShadow: "0px 0px 3px #00000029",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    paymentMethodSelected: {
        cursor: "default",
        opacity: " 0.5;",
    },
    paymentMethodSelectionTitle: {
        fontSize: "18px",
        fontWeight: "bold",
        marginBottom: "10px",
        textAlign: "left",
        lineHeight: "22px",
        color: "#191919",
    },
    titleBorder: { borderBottom: "1px dashed #D6D6D6", marginBottom: "22px" },
    // [theme.breakpoints.up("sm")]: {
    //     paymentRowSubTitle: {
    //         justifyContent: "flex-start",
    //     },
    // },
    paymentMarker: {
        background: "#DC3545 0% 0% no-repeat padding-box",
        color: "#FFFFFF",
        opacity: "1",
        borderRadius: "50%",
        width: "18px",
        height: "18px",
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        paddingLeft: "5px",
        marginRight: "6px",
    },
    [theme.breakpoints.up("md")]: {
        paymentRow: {
            display: "flex",
            flexWrap: "wrap",
        },
        paymentSelection: {
            flexDirection: "column",
        },
        // paymentMethodSelectionTitle: {
        //     fontSize: "10px",
        //     marginBottom: "0px",
        //     textAlign: "center",
        // },
    },
    paymentMethodCard: {
        background: "#ECECEC",
        borderRadius: "3px",
        padding: "22px 20px",
        height: "100%",
    },
    [theme.breakpoints.down("sm")]: {
        columnRow: {
            gridTemplateColumns: "1fr ",
            gap: "0px",
            "& .isMobilePaymentHistory": { padding: "0px 20px 22px 20px", display: "block" },
        },
        paymentHistoryCard: {
            border: "unset",
            borderRadius: "0px",
            background: " #F5F5F5",
            paddingBottom: "0px",
            "& .isDesktopPaymentHistory": { display: "none" },
        },
        paymentMethodCard: {
            height: "auto",
            borderRadius: "0px",
        },
        paymentRowTitle: {
            fontSize: "14px",
            marginBottom: "20px",
            lineHeight: "20px",
        },
        paymentMethodSelectionTitle: {
            fontSize: "14px",
            lineHeight: "20px",
        },
        paymentMethodRow: {
            paddingTop: "10px",
        },
        paymentMethod: {
            width: "81px",
            height: "81px",
        },
    },
    isMobilePayMentHistory: {
        background: "red",
    },
}));

/**
 * Contains style information for the payment history section.
 */
export const PaymentHistoryStyles = makeStyles((theme: Theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
    },
    paymentRow: {
        // borderTop: "1px dashed #D6D6D6",
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        // paddingTop: "22px",
    },
    paymentRowTitle: {
        fontSize: "18px",
        fontWeight: "bold",
        marginBottom: "22px",
    },
    paymentRowSubTitle: {
        display: "flex",
        fontSize: "14px",
        marginBottom: "5px !important",
        gap: "10px",
        color: "#191919",
        lineHeight: "17px",
        justifyContent: "space-between",
        "& > div:first-child": {
            fontWeight: "bold",
            marginRight: "12px",
        },
    },
    [theme.breakpoints.down("sm")]: {
        paymentRowTitle: {
            fontSize: "14px",
            marginBottom: "20px",
        },
        paymentRow: {
            borderTop: "none",
        },
    },
}));
export const RenderPaymentHeaderStyle = makeStyles((theme: Theme) => ({
    payMentHeader: {
        background: "#3C3C3B",
        padding: "22px 20px",
        width: "100%",
        borderBottom: "solid 1px #449B23",
        marginBottom: "20px",
        "& .title": {
            fontSize: "21px",
            lineHeight: "25px",
            color: "#fff",
            fontWeight: "bolder",
        },
    },
    [theme.breakpoints.down("sm")]: {
        payMentHeader: {
            padding: "16px 20px",
            textAlign: "center",
            marginBottom: "0px",
        },
    },
}));
